export default __webpack_public_path__ + "static/media/TOB.c56ebc88.jpg";